import { RSAA } from "redux-api-middleware";
import { withAuth } from '../reducers'
import { itemsFetchData, ticketItemData } from '../actions'

import { URL_API, UPDATE_TICKET_REQUEST, UPDATE_TICKET_SUCCESS, UPDATE_TICKET_FAILED } from "../constants";



export const updateTicket = (id, jData) => {
  return dispatch =>
    dispatch({
      [RSAA]: {
        endpoint: `${URL_API}/request/${id}/`,
        method: 'PUT',
        headers: withAuth({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(jData),
        types: [
          UPDATE_TICKET_REQUEST,
          {
            type: UPDATE_TICKET_SUCCESS,
            payload: (action, state, res) => {
              const { tickets_url } = state
              dispatch(ticketItemData(`${URL_API}/request/${id}/`))
              if (tickets_url.length) {
                dispatch(itemsFetchData(tickets_url))
              } else {
                dispatch(itemsFetchData(`${URL_API}/request/?status=`))
              }
              return res.json()
            }
          },
          UPDATE_TICKET_FAILED
        ]
      }
    })
}


// WEBPACK FOOTER //
// ./src/actions/trackNumber.js